export default function(api: GlobalFetch) {
  return async function() {
    await api.fetch(`/api/v2/user/poll`, {
      method: 'POST',
    })
  }
}
